/* v2-sticky.js - moved out of the page into a cached asset (was inline).
   Runs once per page; in the theme editor it re-runs when a section reloads,
   exactly as the inline version did. */
(function () {
if (window.__v2Asset_v2_sticky_js) return;
window.__v2Asset_v2_sticky_js = 1;
function v2run() {
(function(){
  window.__v2StickyCopies = (window.__v2StickyCopies || 0) + 1;
  window.__v2StickyBuild = 'v2-sticky 2026-09-03b one-body-observer';

  var host = document.querySelector('[data-v2-sticky]');
  if (!host) return;

  if (host.parentNode !== document.body) document.body.appendChild(host);

  function realAdd(){
    var list = document.querySelectorAll(
      '.product-form-buy-buttons-wrapper .product-form__submit,' +
      'product-form button[name="add"], form[action*="/cart/add"] button[name="add"]');
    for (var i = 0; i < list.length; i++) {
      if (!host.contains(list[i])) return list[i];
    }
    return null;
  }

  var btn   = host.querySelector('[data-v2sb-add]');
  var label = host.querySelector('[data-v2sb-label]');
  var out   = host.querySelector('[data-v2sb-price]');
  var fit   = host.querySelector('[data-v2sb-fit]');
  var top   = host.querySelector('[data-v2sb-top]');
  var real  = realAdd();

  var DEBUG = host ? host.getAttribute('data-v2sb-debug') === 'true' : false;
  function say(msg){
    if (!DEBUG) return;
    if (window.console) console.log('[v2-sticky] ' + msg);
  }

  if (!real) {
    say('no Add to cart found on this page, so the bar stays hidden. It looks ' +
        'for .product-form-buy-buttons-wrapper .product-form__submit, ' +
        'product-form button[name="add"], or a button[name="add"] inside a ' +
        'form posting to /cart/add.');
    return;
  }
  say('found the theme Add to cart; the bar will show once it scrolls out of view.');
  host.hidden = false;

  var io = null, realMo = null;
  function rebind(next){
    real = next;
    if (io) { io.disconnect(); io.observe(real); }
    if (realMo) {
      realMo.disconnect();
      realMo.observe(real, {attributes:true, attributeFilter:['disabled'], childList:true, subtree:true});
    }
    mirror();
  }
  function liveReal(){
    if (!real || !document.contains(real)) {
      var next = realAdd();
      if (next && next !== real) { rebind(next); say('the theme replaced its Add to cart; re-bound to the new one.'); }
    }
    return real;
  }

  var addLabel = (label.textContent || 'Add to cart').trim();
  var priceSlot = document.querySelector('[data-v2-price-slot]');
  var askNo = document.querySelector('[data-v2-ask="no"]');
  var askYes = document.querySelector('[data-v2-ask="yes"]');
  var giftBtn = document.querySelector('[data-v2-gift]');

  function textOf(el){ return el ? (el.textContent || '').trim() : ''; }
  function on(el){ return !!el && el.classList.contains('on'); }

  function slotPrice(){
    if (!priceSlot) return '';
    var pub = priceSlot.getAttribute('data-v2-price-text');
    if (pub) return pub.trim();
    if (priceSlot.querySelector('[data-v2-price-moved]')) return '';
    return (priceSlot.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function mirror(){
    var p = slotPrice();
    if (p && out && (out.textContent || '').trim() !== p) out.textContent = p;

    if (real.disabled) {
      btn.disabled = true;
      label.textContent = textOf(real) || 'Sold out';
    } else {
      btn.disabled = false;
      label.textContent = addLabel;
    }

    if (fit) fit.hidden = on(askNo) || on(giftBtn);
    if (typeof fitPrice === 'function') fitPrice();
  }
  mirror();

  if (window.MutationObserver) {
    var mo = new MutationObserver(mirror);
    if (priceSlot) mo.observe(priceSlot, {childList:true, subtree:true, characterData:true,
      attributes:true, attributeFilter:['data-v2-price-text']});
    realMo = new MutationObserver(mirror);
    realMo.observe(real, {attributes:true, attributeFilter:['disabled'], childList:true, subtree:true});
    [askYes, askNo, giftBtn].forEach(function(el){
      if (el) mo.observe(el, {attributes:true, attributeFilter:['class']});
    });
  }

  var row = host.querySelector('.v2sb');

  function fitPrice(){
    btn.removeAttribute('data-tight');
    for (var lvl = 0; lvl <= 2; lvl++) {
      if (lvl) btn.setAttribute('data-fit', String(lvl));
      else btn.removeAttribute('data-fit');
      if (btn.scrollWidth <= btn.clientWidth + 1) return;
    }
    btn.setAttribute('data-tight', '');
  }

  function covered(){
    var els = [btn, fit, top], i, j, el, r, x, y, hit;
    for (i = 0; i < els.length; i++) {
      el = els[i];
      if (!el || el.hidden || !el.getClientRects().length) continue;
      r = el.getBoundingClientRect();
      if (r.width < 4) continue;
      y = Math.round(r.top + r.height / 2);
      for (j = 0; j <= 4; j++) {
        x = Math.round(r.left + 2 + (r.width - 4) * (j / 4));
        hit = document.elementFromPoint(x, y);
        if (!hit || !host.contains(hit)) return true;
      }
    }
    return false;
  }

  function clearCorner(){
    if (!host.hasAttribute('data-open')) return;
    var hr = host.getBoundingClientRect();
    if (hr.bottom > window.innerHeight + 2) return;
    var cap = Math.round(window.innerWidth / 3);
    var pad = 0;
    row.style.paddingRight = '';
    var base = parseFloat(getComputedStyle(row).paddingRight) || 0;
    for (; pad <= cap; pad += 6) {
      if (pad) row.style.paddingRight = (base + pad) + 'px';
      if (!covered()) { if (pad) pad += 6; break; }   /* a hair of daylight */
    }
    if (pad) row.style.paddingRight = (base + pad) + 'px';
    if (pad > cap) row.style.paddingRight = (base + cap) + 'px';
    fitPrice();
  }
  clearCorner();
  fitPrice();
  setTimeout(clearCorner, 1200);
  setTimeout(clearCorner, 4000);
  window.addEventListener('resize', function(){
    clearTimeout(window.__v2sbT);
    window.__v2sbT = setTimeout(clearCorner, 150);
  }, { passive: true });

  function setOpen(o){
    if (o) {
      host.setAttribute('data-open', '');
      host.addEventListener('transitionend', clearCorner, { once: true });
      setTimeout(clearCorner, 320);   /* in case the transition never fires */
    } else host.removeAttribute('data-open');
  }
  if (window.IntersectionObserver) {
    io = new IntersectionObserver(function(e){ setOpen(!e[0].isIntersecting); },
      { rootMargin: '0px 0px -40px 0px' });
    io.observe(real);
  } else {
    window.addEventListener('scroll', function(){
      setOpen(window.pageYOffset > window.innerHeight);
    }, { passive: true });
  }

  function motion(){
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches
      ? 'auto' : 'smooth';
  }

  btn.addEventListener('click', function(){
    var r = liveReal();
    if (!r || r.disabled) return;
    r.click();
  });

  if (fit) fit.addEventListener('click', function(){
    var cta = document.querySelector('[data-pcf-klaviyo], .pcf__btn');
    if (cta && !host.contains(cta)) { cta.click(); return; }
    if (askNo) {
      askNo.click();
      var box = askNo.closest('[data-v2-groups]') || askNo;
      box.scrollIntoView({ behavior: motion(), block: 'center' });
    }
  });

  if (top) top.addEventListener('click', function(){
    window.scrollTo({ top: 0, behavior: motion() });
  });

  function overlayOpen(){
    var lb = document.querySelector('[data-v2-lb]');
    if (lb && !lb.hidden) return true;
    return !!document.querySelector('cart-drawer.active, .drawer.active, [data-v2-cart-open]');
  }
  if (window.MutationObserver) {
    if (window.__v2StickyBodyMo) {
      try { window.__v2StickyBodyMo.disconnect(); } catch (e) {}
    }
    window.__v2StickyBodyMo = new MutationObserver(function(){
      host.style.visibility = overlayOpen() ? 'hidden' : '';
      liveReal();
    });
    window.__v2StickyBodyMo.observe(document.body, {attributes:true, childList:true,
                               subtree:true, attributeFilter:['hidden','class']});
  }

})();
}
v2run();
if (window.Shopify && window.Shopify.designMode) {
document.addEventListener('shopify:section:load', function () { try { v2run(); } catch (e) {} });
}
})();
